const config = {
  name: "build-test",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    userPhoneNumber: true,
    userName: false,
    showAdaSupport: false
  },
  parkingSession: {
    // At midnight on the day of parking
    cancelDaysBefore: 0,
    cancelTime: "00:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 7 am
    startOffsetHrs: 7,
    // Start date offset from today (0 = today)
    startOffsetDate: 1, // Tomorrow
    // End date offset from start time
    endOffsetDate: 160
  }
}
export default config
